/* eslint-disable import/no-anonymous-default-export */
import { Card, Stack } from '@mui/material';
import {
    BulkActionsToolbar,
    BulkDeleteButton,
    CreateButton,
    ListBase,
    ListToolbar,
    Pagination,
    SortButton,
    Title,
    TopToolbar,
    useGetIdentity,
    useListContext,
} from 'react-admin';

import { ProjectFileConfigEmpty } from './ProjectFileConfigEmpty';
import { ProjectFileConfigListContent } from './ProjectFileConfigListContent';
import { ProjectFileConfigListFilter } from './ProjectFileConfigListFilter';

export const ProjectFileConfigList = () => {
    const { identity } = useGetIdentity();

    if (!identity) return null;

    return (
        <ListBase
            disableAuthentication
            perPage={25}
            sort={{ field: 'id', order: 'DESC' }}
        >
            <ProjectFileConfigListLayout />
        </ListBase>
    );
};

const ProjectFileConfigListLayout = () => {
    const { data, isPending, filterValues } = useListContext();
    const { identity } = useGetIdentity();

    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    if (!identity || isPending) return null;

    if (!data?.length && !hasFilters) return <ProjectFileConfigEmpty />;

    return (
        <Stack direction={{ xs: 'column', md: 'row' }} sx={{ width: '100%' }}>
            <ProjectFileConfigListFilter />
            <Stack sx={{ width: '100%', minWidth: 0, flex: 1 }}>
                <Title title={'ProjectFileConfigs'} />
                <ListToolbar actions={<ProjectFileConfigListActions />} />
                <BulkActionsToolbar>
                    <BulkDeleteButton />
                </BulkActionsToolbar>
                <Card>
                    <ProjectFileConfigListContent />
                </Card>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

const ProjectFileConfigListActions = () => (
    <TopToolbar>
        <SortButton fields={['id', 'title', 'file_extension']} />
        <CreateButton
            variant="contained"
            label="New Project File Config"
            sx={{ marginLeft: 2 }}
        />
    </TopToolbar>
);
